import { GQL } from './generated';

/**
 * Get a display string for use on the client to display the column option.
 */
export function getFileFieldDisplayName(col: GQL.ReportColumnFileField): string {
  switch (col) {
    case GQL.ReportColumnFileField.CreatedAt:
      return 'Date Created';
    case GQL.ReportColumnFileField.DeletedAt:
      return 'Date Deleted';
    case GQL.ReportColumnFileField.Id:
      return 'Document Identifier';
    case GQL.ReportColumnFileField.LastAccessedByRequesterAt:
      return 'Last Accessed';
    case GQL.ReportColumnFileField.Name:
      return 'Document Name';
    case GQL.ReportColumnFileField.Owner:
      return 'Owner';
    case GQL.ReportColumnFileField.Parties:
      return 'Parties';
    case GQL.ReportColumnFileField.RequesterFavorited:
      return 'Favorited';
    case GQL.ReportColumnFileField.SignedAt:
      return 'Date Signed';
    case GQL.ReportColumnFileField.Status:
      return 'Status';
    case GQL.ReportColumnFileField.Type:
      return 'Contract Type';
    case GQL.ReportColumnFileField.UpdatedAt:
      return 'Date Updated';
    case GQL.ReportColumnFileField.Labels:
      return 'Labels';
    case GQL.ReportColumnFileField.FileType:
      return 'File Type';
  }
}
